export default __webpack_public_path__ + "static/media/acess_request_2.3a8baef5.png";